module.exports = __webpack_public_path__ + "img/TrackNotAvailable_CV.d9b4fd78.png";